import { IOrganisationIndexGroup } from "../model/OrganisationIndexGroup";
import OrganisationIndexGroupMapper from "../service/OrganisationIndexGroupMapper";
import OrganisationIndexGroupParamMapper from "../service/OrganisationIndexGroupParamMapper";
import GetResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";

export default class FindConnectionCandidatesForGroupInteractor {
  private resource: GetResourceEntriesInteractor<IOrganisationIndexGroup>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(group: IOrganisationIndexGroup) {
    return this.resource.execute(
      `${Constants.organisationsPath}/${group.organisationId}/groups/organisation`,
      OrganisationIndexGroupMapper,
      OrganisationIndexGroupParamMapper,
      {
        params: {
          groupId: group.id
        }
      }
    );
  }
}
